import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Button,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import AboutUsDeskImg from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/AboutUsDesk.png';
import AboutUsMobileImg from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/AboutUsMobile.png';
import Abouts from 'C:/Users/bswarnka/Desktop/About01.jpg';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';

const BannerMobile = styled(Box)({
  position: 'relative',
  height: '200px',
  backgroundImage: `url(${AboutUsMobileImg})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  opacity: 0.7,
  width: '100%',
});

const BannerDesktop = styled(Box)({
  position: 'relative',
  height: '150px',
  backgroundImage: `url(${AboutUsDeskImg})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  opacity: 0.7,
  width: '100%',
});

const About = () => {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();

  const onAppoinmentHandler = () => {
    navigate('/ContactUs');
    setTimeout(() => {
      const section = document.getElementById('specific-section');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }, 300);
  };

  const checkDeviceType = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    checkDeviceType();
    window.addEventListener('resize', checkDeviceType);
    return () => window.removeEventListener('resize', checkDeviceType);
  }, []);

  return (
    <div>
      {/* Banner */}
      {isMobile ? <BannerMobile /> : <BannerDesktop />}

      {/* About Section */}
      <Box
        sx={{
          maxWidth: '1200px',
          margin: 'auto',
          px: { xs: 2, md: 6 },
          py: { xs: 4, md: 8 },
        }}
      >
        <Grid container spacing={4} alignItems="center">
          {/* Left: Image */}
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={Abouts}
              alt="About Us"
              sx={{
                width: '100%',
                borderRadius: 2,
                boxShadow: 2,
              }}
            />
          </Grid>

          {/* Right: Text Content */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Typography variant="h4" sx={{ fontWeight: 600 }}>
                Welcome to Aarogyam Dental Care
              </Typography>

              <Typography variant="subtitle1" sx={{ color: 'green' }}>
                Your trusted dental clinic in the heart of Hyderabad.
              </Typography>

              <Typography variant="body1" sx={{ color: '#444' }}>
                At Aarogyam Dental Care, we provide exceptional dental services tailored to your
                individual needs. Our goal is to keep your smile healthy, confident, and beautiful.
              </Typography>

              <Typography variant="body1" sx={{ color: '#444' }}>
                From regular cleanings to advanced cosmetic procedures, our team of professionals
                delivers compassionate care with cutting-edge technology.
              </Typography>

              <Box sx={{ textAlign: 'center', mt: 3 }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={onAppoinmentHandler}
                >
                  Book an Appointment
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default About;
